export default __webpack_public_path__ + "static/media/avgPace.53801f67.svg";